import { getHashtagsFromApi } from './hashtagApi';

export async function generateHashtags(targetText, numberOfHashtags = 1, setLoading) {
  return getHashtagsFromApi(targetText, numberOfHashtags, setLoading);
}



